import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.timer = null
  }

  input() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  change() {
    clearTimeout(this.timer)
    this.submit()
  }

  submit() {
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }
}
